import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "../components/Reveal";
import { PageHeader } from "./About";
import { useLang } from "../contexts/LanguageContext";
import { t } from "../i18n/translations";
import useSEO from "../hooks/useSEO";

const PARTNER_LOGOS = [
  "https://customer-assets.emergentagent.com/job_youth-care-hk/artifacts/9ppre2li_image.png",
  "https://customer-assets.emergentagent.com/job_youth-care-hk/artifacts/cdz5ws85_image.png",
];

const Partners = () => {
  const { lang } = useLang();
  useSEO({
    title: lang === "en"
      ? "Partners — Schools & NGOs | Revelo"
      : "合作夥伴 — 學校及非牟利機構 | Revelo",
    description: lang === "en"
      ? "Revelo collaborates with schools, NGOs and community organisations to deliver anti-scam education across Hong Kong."
      : "Revelo 與學校、非牟利機構及社區團體合作，在香港推廣反詐騙教育。",
    lang,
  });
  const tr = t[lang];

  return (
    <div data-testid="partners-page">
      <PageHeader
        eyebrow={lang === "en" ? "Partners" : "夥伴"}
        title={tr.partners.title}
        intro={tr.partners.intro}
        heroImage="https://customer-assets.emergentagent.com/job_youth-care-hk/artifacts/acyxl8gm_image.png"
      />

      <section className="py-12 lg:py-20">
        <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12">
          <StaggerGroup className="grid sm:grid-cols-2 gap-6">
            {tr.partners.list.map((p, i) => (
              <StaggerItem key={i}>
                <div data-testid={`partner-card-${i}`} className="h-full flex flex-col items-center justify-center text-center bg-white border border-slate-100 rounded-none p-12 hover:shadow-lg transition-all">
                  <div className="h-56 w-full flex items-center justify-center mb-6">
                    <img src={PARTNER_LOGOS[i]} alt={p} className="max-h-full max-w-[340px] object-contain" />
                  </div>
                  <h3 className="font-heading font-bold text-xl text-[#0A192F]">{p}</h3>
                  <p className="mt-2 text-xs uppercase tracking-widest text-[#E9A229] font-semibold">{lang === "en" ? "Community Partner" : "社區夥伴"}</p>
                </div>
              </StaggerItem>
            ))}
          </StaggerGroup>

          <Reveal className="mt-16 bg-[#F8FAFC] border border-slate-100 rounded-none p-10 lg:p-14 text-center">
            <h3 className="font-heading text-2xl sm:text-3xl font-bold text-[#0A192F]">{lang === "en" ? "Let's build a safer community together" : "一起建立更安全的社區"}</h3>
            <p className="mt-4 text-slate-600 max-w-2xl mx-auto leading-relaxed">{tr.partners.ctaCopy}</p>
            <Link to="/contact?interest=sponsorship" data-testid="partners-cta" className="mt-7 inline-flex items-center gap-2 bg-[#163B71] hover:bg-[#0A192F] text-white px-7 py-3 rounded-full font-bold uppercase tracking-wide text-sm transition-all">
              {tr.partners.ctaButton} <ArrowRight size={16} className="btn-arrow" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Partners;
